import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import {
  agentToolsApi,
  type MCPOAuthInit,
} from "../../../services/agent-tools-service";

type ApiError = {
  response?: {
    data?: { error?: { message?: string }; detail?: string; message?: string };
  };
  message?: string;
};

const extractErrorMessage = (error: ApiError, fallback: string): string => {
  const data = error.response?.data;
  return (
    data?.error?.message ||
    data?.detail ||
    data?.message ||
    error.message ||
    fallback
  );
};

type Options = {
  onSuccess?: (init: MCPOAuthInit) => void;
  onError?: () => void;
};

export const useReconnectMCPConnection = (options: Options = {}) => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (id: string) => agentToolsApi.oauthLogin(id),
    onSuccess: (init) => {
      options.onSuccess?.(init);
    },
    onError: (error: ApiError) => {
      toast.error(extractErrorMessage(error, t("mcpPage.mutation.reauthorizeFailed")));
      options.onError?.();
    },
  });
};
